import emitter from './emitter'
import { onMessage, sendHeartCheck } from './action'
import TYPE from './emitType'
import { getCache, tip } from './utils'
import Sockette from 'sockette'

function normalizeSocketUrl(url) {
  if (!url) return url
  if (/^wss?:\/\//i.test(url)) return url
  return `ws://${url}`
}

export default {
  install: app => {
    const socketUrl = normalizeSocketUrl(getCache().socketUrl)
    const socket = new Sockette(socketUrl, {
      timeout: 3 * 1000, // 尝试重新连接等待时间
      maxAttempts: 10, // 尝试重新连接的最大次数
      onopen(e) {
        socket.ws = e.target
        // 二进制
        socket.ws.binaryType = 'arraybuffer'
        emitter.emit(TYPE.SOCKET_OPEN, e)
        heartCheck()
      },
      onmessage(e) {
        onMessage(e)
      },
      // 尝试重连回调
      onreconnect(e) {
        emitter.emit(TYPE.SOCKET_RECONNECT, e)
      },
      // 最大连接限制时回调
      onmaximum(e) {
        emitter.emit(TYPE.LOGIN_FAIL, { msg: `Maximum number of reconnections exceeded. code: ${e.code}${e.reason ? ', reason: ' + e.reason : ''}, socket url: ${socketUrl}` })
      },
      onclose(e) {
        emitter.emit(TYPE.SOCKET_CLOSE, e)
      },
      onerror(e) {
        emitter.emit(TYPE.SOCKET_ERROR, e)
      }
    })

    // 页面关闭之前
    window.onbeforeunload = () => {
      socket?.ws?.close()
    }

    const send = (byteBuffer) => {
      switch (socket?.ws.readyState) {
        case WebSocket.CONNECTING:
          tip('Socket connecting, Please wait')
          break
        case WebSocket.OPEN:
          socket.send(byteBuffer.buffer.slice(0, byteBuffer.offset))
          break
        case WebSocket.CLOSING:
          tip('Socket closing')
          break
        case WebSocket.CLOSED:
          emitter.emit(TYPE.LOGIN_FAIL, { msg: 'Socket closed' })
          break
        default:
          tip('Socket unknown error, Please try again')
          break
      }
    }

    const heartCheck = (() => {
      let timer = null
      const interval = 1000 * 20
      const timeout = () => {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
          if (socket?.ws.readyState === WebSocket.OPEN) {
            send(sendHeartCheck())
            timeout()
          }
        }, interval)
      }
      return timeout
    })()

    return {
      socket,
      send
    }
  }
}
